import { createSlice } from "@reduxjs/toolkit";
import { manualUploadAction } from "../actions/manualUploadAction";

const initialState = {
  pdfFileNames: [],
  inOfficeFile: null,
  inOfficeFileName: "",
  pdfPreviewUrl: null,
  isSubmitting: false,
  uploadReportId: null,
  selectedPatient: null,
  isSubmitClicked: false,
  showCustomNotes: false,
  isExistingPatient: true,
  selectedBillingCodes: [],
  patientManufacturers: [],
  transmissionType: "remote",
  remoteBillingCodeMapper: null,
  showSwitchUserTypeModal: false,
  showCrossFacilityPatientWarningModal: false,
  selectedCrossFacilityPatient: null,
  patientAdditionalManufacturers: [],
  showAddNewDeviceModal: false,
  isInOfficeUpload: false,
  inOfficeUploadPatientDetails: null,
  showInOfficeUploadPatientFoundDetails: false,
  isUploadingInOfficeFile: false,
  existingPatientFieldValues: null,
  similarPatientsFromInOfficeFile: [],
  inOfficeUploadPatientInformationForManualUpload: null,
  reportTemplates: [],
  patientInfoToUpdate: null,
  missingTemplateBillingCodes: [],
  showMissingBillingCodeTemplateModal: false,
  extractedPdfData: {},
};

const manualUpload = createSlice({
  name: "manualUpload",
  initialState,
  reducers: manualUploadAction,
});

export const {
  setPdfFileNames,
  setIsSubmitting,
  setInOfficeFile,
  setPdfPreviewUrl,
  setUploadReportId,
  setIsSubmitClicked,
  setShowCustomNotes,
  setSelectedPatient,
  setInOfficeFileName,
  setTransmissionType,
  setIsInOfficeUpload,
  setIsExistingPatient,
  setSelectedBillingCodes,
  setPatientManufacturers,
  setShowAddNewDeviceModal,
  setRemoteBillingCodeMapper,
  setShowSwitchUserTypeModal,
  setIsUploadingInOfficeFile,
  setInOfficeUploadPatientDetails,
  setPatientAdditionalManufacturers,
  setShowInOfficeUploadPatientFoundDetails,
  setExistingPatientFieldValues,
  setSimilarPatientsFromInOfficeFile,
  setInOfficeUploadPatientInformationForManualUpload,
  setReportTemplates,
  setShowReportTemplateUpdateAlert,
  setPatientInfoToUpdate,
  setShowCrossFacilityPatientWarningModal,
  setSelectedCrossFacilityPatient,
  setMissingTemplateBillingCodes,
  setShowMissingBillingCodeTemplateModal,
  setExtractedPdfData,
} = manualUpload.actions;

export default manualUpload.reducer;
